export const formType = {
  INSERT: 'insert_form',
  UPDATE: 'update_form',
  DELETE: 'delete_form',
  VIEW: 'view_form',
};
